export enum FeatureFlagSource {
  /** Flags managed by the local environment */
  Local = 'local',
  /** Flags managed by Statsig */
  Statsig = 'statsig',
}

type FeatureFlagType = {
  source: FeatureFlagSource;
  enabled: boolean;
  flag: string;
};

/**
 * All feature flags must be disabled by default.
 * @description Default feature flag values cannot be mutated.
 */
export const defaultFeatureFlagState = {
  'local.test': {
    source: FeatureFlagSource.Local,
    enabled: false,
    flag: 'local.test',
  },
  'databases-frontend-attachment-multi-by-default': {
    source: FeatureFlagSource.Statsig,
    enabled: false,
    flag: 'databases-frontend-attachment-multi-by-default',
  },
  'databases-frontend-layout-calendar': {
    source: FeatureFlagSource.Statsig,
    enabled: false,
    flag: 'databases-frontend-layout-calendar',
  },
  'databases-frontend-presence': {
    source: FeatureFlagSource.Statsig,
    enabled: false,
    flag: 'databases-frontend-presence',
  },
  'databases-frontend-checkbox-field-type': {
    source: FeatureFlagSource.Statsig,
    enabled: false,
    flag: 'databases-frontend-checkbox-field-type',
  },
  'databases-frontend-import-m1': {
    source: FeatureFlagSource.Statsig,
    enabled: false,
    flag: 'databases-frontend-import-m1',
  },
  'databases-frontend-mentions-notifications-checkbox': {
    source: FeatureFlagSource.Statsig,
    enabled: false,
    flag: 'databases-frontend-mentions-notifications-checkbox',
  },
  'databases-frontend-inline-comments': {
    source: FeatureFlagSource.Statsig,
    enabled: false,
    flag: 'databases-frontend-inline-comments',
  },
  'databases-frontend-import-m2': {
    source: FeatureFlagSource.Statsig,
    enabled: false,
    flag: 'databases-frontend-import-m2',
  },
  'databases-frontend-mentions-notifications-flag': {
    source: FeatureFlagSource.Statsig,
    enabled: false,
    flag: 'databases-frontend-mentions-notifications-flag',
  },
  'platform-visual-refresh-icons': {
    source: FeatureFlagSource.Statsig,
    enabled: false,
    flag: 'platform-visual-refresh-icons',
  },
  'database-frontend-cell-interactions-m0': {
    source: FeatureFlagSource.Statsig,
    enabled: false,
    flag: 'database-frontend-cell-interactions-m0',
  },
} as const satisfies Record<string, FeatureFlagType>;

export type FeatureFlagKey = keyof typeof defaultFeatureFlagState;
export type FeatureFlags = Record<FeatureFlagKey, FeatureFlagType>;

export type FeatureFlagsType = { [key: string]: boolean };
